import { getConfig } from '@cmctechnology/webinvest-store-frontend';
import { Config } from '@forgerock/javascript-sdk';
import { FR_REALM_PATH, FR_SCOPES, FR_WEB_OAUTH_CLIENT, HEADER_FR_X_APP_BRAND, HEADER_FR_X_APP_CLIENT_ID } from '../constants/FRConstants';
import { JourneyTree } from '../constants/FREnums';
import { STORAGE_KEYS } from '@cmctechnology/webinvest-constants';
import { Action, RequestObj } from '@forgerock/javascript-sdk/dist/config/interfaces';

export * as CMCFRSDK from '@forgerock/javascript-sdk';

const forceAuthMap: Partial<Record<JourneyTree, boolean>> = {
  [JourneyTree.FR_JOURNEY_CHANGE_PASSWORD]: true,
  [JourneyTree.FR_JOURNEY_CHANGE_USERNAME]: true,
  [JourneyTree.FR_JOURNEY_DISABLE_MFA]: true,
  [JourneyTree.FR_JOURNEY_REGISTER_MFA]: true,
  [JourneyTree.FR_JOURNEY_CHANGE_PASSWORD_V2]: true,
  [JourneyTree.FR_JOURNEY_CHANGE_USERNAME_V2]: true,
  [JourneyTree.FR_JOURNEY_DISABLE_MFA_V2]: true,
  [JourneyTree.FR_JOURNEY_REGISTER_MFA_V2]: true
};

const appendForceAuthMiddleware = (req: RequestObj, action: Action, next: () => RequestObj): void => {
  if (action.type === `START_AUTHENTICATE` || action.type === `AUTHENTICATE`) {
    const url = req.url.searchParams as URLSearchParams;
    url.append(`ForceAuth`, `true`);
  }
  next();
};

const appendHeadersMiddleware = (req: RequestObj, action: Action, next: () => RequestObj): void => {
  if (action.type !== `AUTHORIZE`) {
    const brand = localStorage.getItem(STORAGE_KEYS.Theme);
    const headers = req.init.headers as Headers;

    headers.append(HEADER_FR_X_APP_CLIENT_ID, FR_WEB_OAUTH_CLIENT);

    if (brand) {
      headers.append(HEADER_FR_X_APP_BRAND, brand);
    }
  }
  next();
};

export const useFRConfig = (tree: JourneyTree, redirectUrl?: string) => {
  // the redirect url that forgerock redirects internally, within an auth iframe when acquiring tokens.
  // a static html file that's hosted under the same env domain e.g. {hostUrl}/redirect.html.
  // lives in the public folder of webinvest-frontend.
  const redirectUri = redirectUrl ?? `${getConfig().hostUrl}/redirect.html`;
  const forceAuthMiddleware = forceAuthMap[tree] ? [appendForceAuthMiddleware] : [];
  const headersMiddleware = [appendHeadersMiddleware];
  const middleware = [...forceAuthMiddleware, ...headersMiddleware];

  Config.set({
    clientId: `${FR_WEB_OAUTH_CLIENT}`,
    middleware,
    redirectUri,
    scope: FR_SCOPES,
    serverConfig: {
      baseUrl: `${getConfig().forgerockBaseUrl}/am`,
      timeout: 120_000
    },
    realmPath: FR_REALM_PATH,
    tree,
    tokenStore: `localStorage`
  });
};
